import { HTMLAttributes } from 'react'
import { map } from 'lodash'

import ColumnsCard from '@/components/base/columns-card'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'

import { useGridMotion } from './motion/grid'
import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type NewsroomGridProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    collection: {
      id: number
      title: { rendered: string }
      link: string
      featured_image: WPImage
    }[]
  }>

const NewsroomGrid = ({ collection, ...props }: NewsroomGridProps) => {
  const { motionRef } = useGridMotion()

  return (
    <Section ref={motionRef} {...props}>
      <Container>
        <Grid className="items-start gap-y-[10rem]">
          {map(collection, ({ id, title, featured_image, link }) => (
            <ColumnsCard
              key={`card-${id}`}
              title={title?.rendered}
              image={featured_image}
              link={link}
              className={cn(
                'col-span-2 md:col-span-3 lg:col-span-6',
                'size-full lg:grid-rows-none'
              )}
              data-motion-card
            />
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default NewsroomGrid
